export enum DestinationPrefix {
    Pub = 'Pub',
    Ads = 'Ads'
}
